/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_PermissionInputs */

const de__field_permission = /** @type {(inputs: _Field_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechtigung`)
};

/**

* @param {_Field_PermissionInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_permission = /** @type {((inputs?: _Field_PermissionInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_PermissionInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_permission(inputs)
});